import * as yup from "yup";

const spaceCheckYupValidation = (val?: string) => val ? (!/^\s*$/.test(val)) : false

export const AddProviderSchema = (ref_type: string) => {
  const addProvider = yup.object({
    npi: yup
      .string()
      .required(`NPI value is required to fetch details`)
      .min(10, `NPI value is required to fetch details`)
      .max(10, `NPI value is required to fetch details`)
      .test(
        "onlyNumbers", // type of the validator (should be unique)
        `NPI should only contain numbers`, // error message
        (value) => /^\d+$/.test(value)
      )
      .test(
        "noEOrSign", // type of the validator (should be unique)
        `NPI should only contain numbers`, // error message
        (value) => !/[eE+-]/.test(value.toString())
      ),
    ref_taxonomy_id: yup
      .string()
      .required("Taxonomy is required")
      .test("whiteSpaceRemoval", "Taxonomy is required", (val) => spaceCheckYupValidation(val)),
    firstname: yup
      .string()
      .required("First name is required")
      .max(35, `First name should only be 35 characters long`)
      .test("whiteSpaceRemoval", "First name should not contain only spaces", (val) => spaceCheckYupValidation(val)),
    lastname: yup
      .string()
      .required("Last name is required")
      .max(35, `Last name should only be 35 characters long`)
      .test("whiteSpaceRemoval", "Last name should not contain only spaces", (val) => spaceCheckYupValidation(val)),
    dea: yup
      .string()
      .when({
        is: (val:string) => val && val.length > 0,
        then: (schema) =>
          schema
            .min(9, "DEA should contain only 9 digits")
            .max(9, "DEA should contain only 9 digits")
            .test('CheckForInvalidChars', 'DEA is invalid', (val) => (val ? /^[a-z0-9]+$/i.test(val) : true)),
      }),
    sln: yup
      .string()
      .when({
        is: (val: string) => val && val.length > 0,
        then: (schema) => schema
          .test("whiteSpaceRemoval", "SLN should not contain only spaces", (val) => spaceCheckYupValidation(val)),
      }),
    tax_id: yup
      .string()
      .max(9, `Tax ID should contain only 9 digits`)
      .when({
        is: (val: string) => val && val.length > 0,
        then: (schema) => schema
          .test('CheckForInvalidChars', 'Tax ID is invalid', (val) => (val ? /^[a-z0-9]+$/i.test(val) : true)),
      }),
    ptan: yup
      .string()
      .when({
        is: (val: string) => val && val.length > 0,
        then: (schema) => schema
        .test("whiteSpaceRemoval", "PTAN should not contain only spaces", (val) => spaceCheckYupValidation(val)),
      })
  });

  const practiceField =
    ref_type !== "Organization"
      ? { practice_id: yup.number().required("Practice is required") }
      : {
          practice_id: yup
            .array()
            .of(yup.number().required("Practice is required"))
            .min(1, `Practice is required`)
            .required(`Practice is required`),
        };

  return addProvider.shape(practiceField);
}
